<template>
    <div class="ManageAccount">
        <h1>
            <v-icon
                v-if="screen_width > 335"
                x-large
                elevation="10"
                class="white--text"
                style="height: 50px; width: 50px; background-color: #009688; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiAccountCog }}
            </v-icon>
            <span>Manage Account</span>
        </h1>
        <v-alert
            v-model="notif.show"
            transition="scroll-x-reverse-transition"
            class="alertNotif"
            :color="notif.type"
            :type="notif.type"
        >
            {{ notif.msg }}
        </v-alert>
        <v-card class="manageAccountBody">
            <v-alert
                dense
                outlined
                type="info"
                color="teal darken-4"
                elevation="2"
            >
                Kindly contact HMI to change your username, email, and contact person.
            </v-alert>
            <v-text-field
                label="Username"
                :value="accountCred.USERNAME"
                color="#009688"
                outlined
                :prepend-inner-icon="mdiHospitalBuilding"
                readonly
                autocomplete="nope"
            />
            <v-text-field
                label="Email"
                :value="accountCred.EMAIL"
                color="#009688"
                outlined
                :prepend-inner-icon="mdiEmail"
                readonly
                autocomplete="nope"
            />
            <v-text-field
                label="PIC Name"
                :value="toTitleCase(accountCred.PIC_NAME)"
                color="#009688"
                outlined
                :prepend-inner-icon="mdiAccount"
                readonly
                autocomplete="nope"
            />
            <v-text-field
                label="PIC Contact No."
                :value="accountCred.PIC_CPNO"
                color="#009688"
                outlined
                :prepend-inner-icon="mdiCellphoneBasic"
                readonly
                autocomplete="nope"
            />
            <v-text-field
                label="Password Expiry Date"
                :value="getPasswordExpiry(accountCred.PWORD_UPDATE_AT)"
                color="#009688"
                outlined
                :prepend-inner-icon="mdiLockClock"
                readonly
                autocomplete="nope"
            />
            <v-btn
                style="display: block; max-width: 250px; background-color: #009688; color: white;"
                class="white--text"
                @click="showPass = !showPass"
            >
                <v-icon>{{ mdiLock }}</v-icon> Change password
            </v-btn>
            <ChangePassword
                :show="showPass"
                @closeChangePass="showPass = false"
                @msgChangePass="msgChangePass"
            />
        </v-card>
    </div>
</template>

<script>
// TODO: Sticky error message in ChangePassword
import UserCookie from 'vue-cookies'
import ChangePassword from './FormChangePass.vue'
import { mapActions, mapGetters } from 'vuex'
import { moment } from '../../../utils/date-shim'
import { mdiAccount, mdiAccountCog, mdiCellphoneBasic, mdiEmail, mdiHospitalBuilding, mdiLock, mdiLockClock } from '@mdi/js'
export default {
    components: {
        ChangePassword
    },
    data: ()=>({
        mdiAccount, mdiAccountCog, mdiCellphoneBasic, mdiEmail, mdiHospitalBuilding, mdiLock, mdiLockClock,
        notif: {
            msg: '',
            show: false,
            type: null
        },
        showPass: false,
        screen_width: document.documentElement.clientWidth + 9,
        exp_days: process.env.VUE_APP_PWORD_EXPIRY
    }),
    computed: {
        ...mapGetters(['accountCred'])
    },
    async mounted(){
        window.addEventListener('resize', this.onResize)
        const PROVIDER_ID   = UserCookie.get('provider_id')
        const USERNAME      = UserCookie.get('username')
        await this.getAccountDetails({ PROVIDER_ID, USERNAME })
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['getCsrfToken', 'getAccountDetails']),
        toTitleCase(str) {
            return str.toUpperCase()
        },
        msgChangePass(data) {
            if (data.status!==200) {
                this.notif.type     = 'error'
                this.notif.msg      = data.state
            } else {
                this.notif.type     = 'success'
                this.notif.msg      = 'Password Updated Successfully!'
            }
            this.notif.show = true
            setTimeout(()=>{ this.notif.show = false }, 3000)
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        },
        getPasswordExpiry(date) {
            return moment(date).utcOffset('+0800').add(this.exp_days, 'days').format('D MMMM YYYY')
        }
    }
}
</script>

<style scoped>
h1 {
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
.manageAccountBody {
    margin-top: 5%;
    padding: 3%;
}
.manageAccount {
    padding: 10px 7.5% 0 7.5%;
}
.alertNotif {
    position: fixed;
    top: 20px;
    right: 6%;
    z-index: 999;
}
@media (max-width: 380px) {
  .ManageAccount {
    padding: 70px 7.5% 0 7.5%;
  }
  .alertNotif {
    position: fixed;
    top: 10px;
    right: 6%;
    z-index: 999;
  }
}
@media (max-width: 599px) {
  .ManageAccount {
    padding: 70px 7.5% 0 7.5%;
  }
  .alertNotif {
    position: fixed;
    top: 80px;
    right: 6%;
    z-index: 999;
  }
}
@media (min-width: 599px) and (max-width: 1264px) {
  .ManageAccount {
    padding: 70px 7.5% 0 7.5%;
  }
  .alertNotif {
    position: fixed;
    top: 80px;
    right: 7.5%;
    z-index: 999;
  }
}
@media (min-width: 1264px) {
  .ManageAccount {
    padding: 10px 7.5% 0 7.5%;
  }
  .alertNotif {
    position: fixed;
    top: 20px;
    right: 6%;
    z-index: 999;
  }
}
</style>
